import * as React from 'react';
import { SVGProps } from 'react';

const IconWindowSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 6.5h8v2H4v-2ZM4 9.5h4v2H4v-2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2Zm1 4v8h10V5H3Z"
    />
  </svg>
);
export default IconWindowSizeS;
